var _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 20,
    height: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5d78ff",
    opacity: 0.3,
    d: "M7.333,3v.417a1.25,1.25,0,0,0,1.25,1.25H12.75A1.25,1.25,0,0,0,14,3.417V3h1.667a1.667,1.667,0,0,1,1.667,1.667V18a1.667,1.667,0,0,1-1.667,1.667h-10A1.667,1.667,0,0,1,4,18V4.667A1.667,1.667,0,0,1,5.667,3Z",
    transform: "translate(-0.667 -0.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5d78ff",
    className: "c",
    d: "M10.667,1.833a.833.833,0,0,1,1.667,0h1.25A.417.417,0,0,1,14,2.25v.833a.417.417,0,0,1-.417.417H9.417A.417.417,0,0,1,9,3.083V2.25a.417.417,0,0,1,.417-.417Z",
    transform: "translate(-1.5 -0.167)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#5d78ff",
    opacity: 0.3,
    width: 5.833,
    height: 1.667,
    rx: 0.833,
    transform: "translate(8.333 7.5)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#5d78ff",
    opacity: 0.3,
    width: 1.667,
    height: 1.667,
    rx: 0.833,
    transform: "translate(5.833 7.5)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    fill: "#5d78ff",
    opacity: 0.3,
    width: 1.667,
    height: 1.667,
    rx: 0.833,
    transform: "translate(5.833 10.833)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    fill: "#5d78ff",
    opacity: 0.3,
    width: 5.833,
    height: 1.667,
    rx: 0.833,
    transform: "translate(8.333 10.833)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    fill: "#5d78ff",
    opacity: 0.3,
    width: 1.667,
    height: 1.667,
    rx: 0.833,
    transform: "translate(5.833 14.167)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    fill: "#5d78ff",
    opacity: 0.3,
    width: 5.833,
    height: 1.667,
    rx: 0.833,
    transform: "translate(8.333 14.167)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDock);
export default __webpack_public_path__ + "static/media/dock.9e1c16aff35d507f025854371a8b2842.svg";
export { ForwardRef as ReactComponent };